module.exports = __webpack_public_path__ + "static/media/call.5c8217ea.png";